"use client";

import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useSearchParams, useRouter } from "next/navigation";

export default function LoginPage() {
  const { login } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const router = useRouter();
  const searchParams = useSearchParams();
  const redirect = searchParams.get("redirect");

async function handleSubmit(e: React.FormEvent) {
  e.preventDefault();
  setError(null);
  setLoading(true);

  try {
    const res = await fetch("https://api.nexbid.pro/auth/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.error || "LOGIN_FAILED");
    }

    login(
      data.token,
      data.role,
      data.approved,
      data.nickname
    );

    if (data.role === "ADMIN" || data.role === "OPERATOR") {
      router.push("/operator");
    } else {
      router.push(redirect || "/");
    }

  } catch (err: any) {
    console.error("LOGIN ERROR:", err.message);
    setError("Email ou senha inválidos");
  } finally {
    setLoading(false);
  }
}
  return (
    <div style={{ maxWidth: 400, margin: "80px auto" }}>
      <h1>Login NexBid</h1>

      {error && (
        <div style={{ color: "red", marginBottom: 10 }}>
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={{ width: "100%", marginBottom: 10 }}
        />

        <input
          type="password"
          placeholder="Senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={{ width: "100%", marginBottom: 10 }}
        />

        <button disabled={loading} style={{ width: "100%" }}>
          {loading ? "Entrando..." : "Entrar"}
        </button>
      </form>
    </div>
  );
}

